var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vuestic-tree-node",
      class: { "vuestic-tree-node-selected": _vm.selected },
    },
    [
      _vm.$slots.checkbox
        ? _c(
            "div",
            { staticClass: "vuestic-tree-node-checkbox" },
            [_vm._t("checkbox")],
            2
          )
        : _vm._e(),
      _vm.$slots.icon
        ? _c(
            "div",
            { staticClass: "vuestic-tree-node-icon" },
            [_vm._t("icon")],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "vuestic-tree-node-label" },
        [_vm._t("default")],
        2
      ),
      _vm.$slots.iconRight
        ? _c(
            "div",
            { staticClass: "vuestic-tree-node-icon-right" },
            [_vm._t("iconRight")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }